var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.8724 10.427H4.1224C1.63365 10.427 0.570312 9.36371 0.570312 6.87496V4.12496C0.570312 1.63621 1.63365 0.572876 4.1224 0.572876H5.03906C5.22698 0.572876 5.38281 0.728709 5.38281 0.916626C5.38281 1.10454 5.22698 1.26038 5.03906 1.26038H4.1224C2.00948 1.26038 1.25781 2.01204 1.25781 4.12496V6.87496C1.25781 8.98788 2.00948 9.73954 4.1224 9.73954H6.8724C8.98531 9.73954 9.73698 8.98788 9.73698 6.87496V5.95829C9.73698 5.77038 9.89281 5.61454 10.0807 5.61454C10.2686 5.61454 10.4245 5.77038 10.4245 5.95829V6.87496C10.4245 9.36371 9.36115 10.427 6.8724 10.427Z",
    fill: "#039855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.8983 8.10788C3.61872 8.10788 3.36205 8.00705 3.17413 7.82372C2.94955 7.59913 2.8533 7.27372 2.90372 6.92997L3.1008 5.55038C3.13747 5.28455 3.31163 4.9408 3.49955 4.75288L7.11122 1.14122C8.0233 0.229133 8.94913 0.229133 9.86122 1.14122C10.3608 1.6408 10.5854 2.14955 10.5396 2.6583C10.4983 3.0708 10.2783 3.47413 9.86122 3.88663L6.24955 7.4983C6.06163 7.68622 5.71788 7.86038 5.45205 7.89705L4.07247 8.09413C4.01288 8.10788 3.9533 8.10788 3.8983 8.10788ZM7.59705 1.62705L3.98538 5.23872C3.8983 5.3258 3.79747 5.52747 3.77913 5.64663L3.58205 7.02622C3.56372 7.15913 3.59122 7.26913 3.65997 7.33788C3.72872 7.40663 3.83872 7.43413 3.97163 7.4158L5.35122 7.21872C5.47038 7.20038 5.67663 7.09955 5.75913 7.01247L9.3708 3.4008C9.66872 3.10288 9.82455 2.83705 9.84747 2.58955C9.87497 2.29163 9.71913 1.97538 9.3708 1.62247C8.63747 0.889132 8.1333 1.09538 7.59705 1.62705Z",
    fill: "#039855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.09894 4.50538C9.06686 4.50538 9.03477 4.50079 9.00727 4.49163C7.80186 4.15246 6.84394 3.19454 6.50477 1.98913C6.45436 1.80579 6.55977 1.61788 6.74311 1.56288C6.92644 1.51246 7.11436 1.61788 7.16477 1.80121C7.43977 2.77746 8.21436 3.55204 9.19061 3.82704C9.37394 3.87746 9.47936 4.06996 9.42894 4.25329C9.38769 4.40913 9.25019 4.50538 9.09894 4.50538Z",
    fill: "#039855"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.bfa807bb4199e7169a3a046105fbc23c.svg";
export { ForwardRef as ReactComponent };